/** @jsx jsx */
import { jsx } from '@emotion/core';

import { Button } from '@zapier/design-system';

import OutsideClickable from 'app/developer-v3/components/OutsideClickable';
import Timeout from 'app/developer-v3/components/Timeout';

type Props = {
  /** Button text to be rendered before the user has clicked */
  actionText: string;
  /** Button text to be rendered once the user has clicked */
  confirmationText: string;
  /** Toggles the confirming mode */
  isConfirming: boolean;
  /** Triggered when the user clicks the button while it's not confirming */
  onClick: () => void;
  /** Triggered when the user clicks the button while it's confirming */
  onConfirm: () => void;
  /** Triggered when the user cancels the operation */
  onCancel: () => void;
  /** Renders a disabled button */
  isDisabled?: boolean;
  timesOut?: boolean;
};
const confirmationTimeout = 3000;

const ConfirmationButton = ({
  actionText,
  confirmationText,
  isConfirming,
  onClick,
  onConfirm,
  onCancel,
  isDisabled,
  timesOut,
}: Props) => {
  const button = (
    <Button
      variant={isConfirming ? 'danger' : 'secondary'}
      isDisabled={isDisabled}
      isFullWidth={isConfirming}
      onPress={isConfirming ? onConfirm : onClick}
    >
      {isConfirming ? confirmationText : actionText}
    </Button>
  );

  return isConfirming ? (
    <Timeout
      delay={confirmationTimeout}
      isWaiting={timesOut}
      onTimeout={onCancel}
    >
      <OutsideClickable onClickOutside={onCancel}>{button}</OutsideClickable>
    </Timeout>
  ) : (
    button
  );
};

export default ConfirmationButton;
